/**
 * Zepto Product Personalizer → Palo Alto Cart Drawer integration
 *
 * Zepto checks for window.pplr_update_minicart after a personalised
 * product has been successfully added/processed.
 */
window.pplr_update_minicart = async function (cart) {
  const cartItems = document.querySelector('cart-items');

  // Safe fallback if the Palo Alto drawer isn't available.
  if (!cartItems) {
    window.location.href = '/cart';
    return;
  }

  try {
    // Fetch and render the latest Shopify cart.
    if (typeof cartItems.getCart === 'function') {
      await cartItems.getCart();
    }

    // Open Palo Alto's native cart drawer.
    if (typeof cartItems.openCartDrawer === 'function') {
      cartItems.openCartDrawer();
      return;
    }

    // Drawer API unavailable — use normal cart page.
    window.location.href = '/cart';
  } catch (error) {
    console.error(
      'Zepto / Palo Alto cart drawer integration failed:',
      error
    );

    window.location.href = '/cart';
  }
};